module.exports = __webpack_public_path__ + "img/logo-white.a0b350c7.png";